import actions from "./actions";
import { message } from "antd";
// import { object } from 'prop-types';
import axios from "axios";
import moment from "moment";

const { DataService } = require("../../config/dataService/dataService");
const { API } = require("../../config/api/index");

const { getMenuItemsData } = actions;

export const menuItemsListData = (tableId, obj) => {
  return async (dispatch) => {
    let url = `${API.tableMenuData}/${tableId}`;
    if (obj && obj.startDate && obj.endDate) {
      url = `${url}?startDate=${obj.startDate}&endDate=${obj.endDate}`;
    }
    const getData = await DataService.get(url);
    if (!getData.data.error) {
      return dispatch(getMenuItemsData(getData?.data?.data));
    } else {
      message.error(getData.data.message);
      return false;
    }
  };
};

export const getHotelDetails = (tableId) => {
  return async (dispatch) => {
    // no hotel id in the route/query means there is nothing to fetch,
    // bail out instead of hitting booking_setup/get/undefined
    if (!tableId || tableId === "undefined") {
      return false;
    }
    const getData = await DataService.get(`${API.hotelDetails}/${tableId}`);
    if (!getData.data.error) {
      return getData.data;
    } else {
      message.error(getData.data.message);
      return false;
    }
  };
};
export const addOrUpdateReseration = (orderData) => {
  return async (dispatch) => {
    const getData = await DataService.post(`${API.createOrder}`, orderData);
    if (!getData.data.error) {
      return getData.data;
    } else {
      message.error(getData.data.message);
      return false;
    }
  };
};
export const addBookingInChannel = (payload) => {
  return async (dispatch) => {
    try {
      let token = payload?.ota_token;
      // let localProviderCode = "JaTkrvpsR0f0T8MUnK70";
      let providerCode = "ggdyFUXCfUzJj0DNjPDE";
      delete payload?.ota_token;
      let response = await axios.post(
        "https://www.eglobe-solutions.com/webapichannelmanager/extpms/bookings/notif",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            ProviderCode: providerCode,
          },
        },
      );

      return response;
    } catch (err) {
      console.log("errerrerrerrerrerrerrerrerr", err);
      return false;
    }
  };
};
export const razorpayCreateOrder = (orderData) => {
  return async (dispatch) => {
    const getData = await DataService.post(
      `${API.razorpayCreateOrder}`,
      orderData,
    );
    return getData;
  };
};
// DataService resolves a 2xx as the axios response but an HTTP error as the
// bare body (see the error interceptor), so hand back the body either way.
// Network errors reject: return false instead of throwing.
const toResponseBody = (response) =>
  response && response.config && response.headers ? response.data : response;

// stores the booking on the server and opens a Razorpay order for it
export const createBookingEngineOrder = (body) => {
  return async (dispatch) => {
    try {
      const response = await DataService.post(API.bookingEngineOrder, body);
      return toResponseBody(response);
    } catch (err) {
      return false;
    }
  };
};
// body = Checkout handler response (razorpay_order_id / _payment_id / _signature)
export const confirmBookingEnginePayment = (body) => {
  return async (dispatch) => {
    try {
      const response = await DataService.post(API.bookingEngineConfirm, body);
      return toResponseBody(response);
    } catch (err) {
      return false;
    }
  };
};
export const getBookingEnginePaymentStatus = (orderId) => {
  return async (dispatch) => {
    try {
      const response = await DataService.get(
        `${API.bookingEngineStatus}/${orderId}`,
      );
      return toResponseBody(response);
    } catch (err) {
      return false;
    }
  };
};
export const getAllRateDateWise = (registerId, obj) => {
  return async (dispatch) => {
    try {
      let url = API.getAllRates;
      if (registerId && obj) {
        url = `${API.getAllRates}?registerId=${registerId}&startDate=${obj.startDate}&endDate=${obj.endDate}`;
      }
      const getroomTypeList = await DataService.get(url);
      if (!getroomTypeList.data.error) {
        return getroomTypeList.data;
      } else {
        return getroomTypeList.data;
      }
    } catch (err) {
      return false;
    }
  };
};
export const checkRoomAvailblity = (payload) => {
  return async (dispatch) => {
    try {
      payload["timeZone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const getroomTypeList = await DataService.post(API.checkRoom, payload);
      if (!getroomTypeList.data.error) {
        return getroomTypeList.data;
      } else {
        return getroomTypeList.data;
      }
    } catch (err) {
      return false;
    }
  };
};
export const updateChannelAvailability = (channel_key, payload) => {
  return async (dispatch) => {
    try {
      let response = await axios.post(
        `https://www.eglobe-solutions.com/webapichannelmanager/inventory/${channel_key}/bulkupdate/v2`,
        payload,
      );
      return response;
    } catch (err) {
      console.log("updateChannelAvailability error", err?.response?.data || err);
      return false;
    }
  };
};
// Push OTA availability to eGlobe with the same numbers the PMS Rates &
// Inventory OTA row shows: ota_sell (first rate plan, falls back to total
// rooms) minus rooms booked that night.
export const syncOTAAvailability = (registerData, roomInfoList) => {
  return async (dispatch) => {
    try {
      if (!registerData?.connect_channel || !registerData?.channel_key) {
        return false;
      }

      // one entry per room type covering the full date span to refresh
      let roomTypeObj = {};
      (roomInfoList || []).forEach((g) => {
        let roomTypeId = g?.room_type?._id;
        let channelRoomCode = g?.room_type?.channel_room_code;
        if (
          !roomTypeId ||
          !channelRoomCode ||
          !g?.reservationInDateAndTime ||
          !g?.reservationOutDateAndTime
        ) {
          return;
        }
        let start = moment(g.reservationInDateAndTime);
        let end = moment(g.reservationOutDateAndTime);
        let existing = roomTypeObj[roomTypeId];
        if (existing) {
          if (start.isBefore(existing.start)) existing.start = start;
          if (end.isAfter(existing.end)) existing.end = end;
          return;
        }
        let roomCount = g.room_type.numberOfRooms;
        roomTypeObj[roomTypeId] = {
          room_type_id: roomTypeId,
          channel_room_code: channelRoomCode,
          totalRooms: Number(
            Array.isArray(roomCount) ? roomCount.length : roomCount || 0,
          ),
          rate_id:
            g.room_type.rate_plan_list?.[0]?.rate_id ||
            g.room_type.rate_plan?.[0]?.rate_id,
          start,
          end,
        };
      });

      for (let oneRoomType of Object.values(roomTypeObj)) {
        const rateList = await dispatch(
          getAllRateDateWise(registerData._id, {
            startDate: moment(oneRoomType.start).format("MM/DD/YYYY"),
            endDate: moment(oneRoomType.end)
              .subtract(1, "days")
              .format("MM/DD/YYYY"),
          }),
        );
        let rateObj = {};
        (rateList?.data || []).forEach((k) => {
          rateObj[`${moment(k.date).format("MM/DD/YYYY")}-${k.rate_id}`] = k;
        });

        // rooms booked per night; check-availability is public (guests have
        // no login) and its end date is the last night, inclusive
        let lastNight = moment(oneRoomType.end).subtract(1, "days");
        let response = await dispatch(
          checkRoomAvailblity({
            reservationStartDate: moment(oneRoomType.start).format("YYYY-MM-DD"),
            reservationEndDate: lastNight.format("YYYY-MM-DD"),
            roomTypeId: oneRoomType.room_type_id,
            needRoom: 0,
            totalRoom: oneRoomType.totalRooms,
          }),
        );
        let totalArray = response?.data?.totalArray;
        if (!Array.isArray(totalArray)) continue;
        let reservedByDate = {};
        totalArray.forEach((k) => {
          reservedByDate[k.date] = Number(k.reserved) || 0;
        });

        let inventory = [];
        let day = moment(oneRoomType.start);
        while (day.isBefore(oneRoomType.end)) {
          let key = day.format("MM/DD/YYYY");
          let otaSell = rateObj[`${key}-${oneRoomType.rate_id}`]?.value?.ota_sell;
          let sellQty =
            otaSell != undefined && otaSell !== ""
              ? Number(otaSell)
              : oneRoomType.totalRooms;
          let available =
            sellQty - (reservedByDate[day.format("YYYY-MM-DD")] || 0);
          inventory.push({
            DateFrom: day.format("DD-MMM-YYYY"),
            DateTill: day.format("DD-MMM-YYYY"),
            RoomCode: oneRoomType.channel_room_code,
            Availability: available < 0 ? 0 : available,
          });
          day.add(1, "days");
        }

        if (inventory.length) {
          await dispatch(
            updateChannelAvailability(registerData.channel_key, {
              RoomWiseInventory: inventory,
            }),
          );
        }
      }
      return true;
    } catch (err) {
      console.log("syncOTAAvailability error", err);
      return false;
    }
  };
};
